/**
 * SuggestedQueries Component
 * Displays suggested queries for the user to click
 */

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { SuggestedQuery } from '../types';

interface SuggestedQueriesProps {
  queries: SuggestedQuery[];
  onSelectQuery: (query: string) => void;
  className?: string;
}

export const SuggestedQueries = ({ queries, onSelectQuery, className }: SuggestedQueriesProps) => {
  if (!queries || queries.length === 0) {
    return null;
  }

  // Determine layout based on text length
  const hasLongQueries = queries.some((q) => q.text.length > 40);

  return (
    <div className={cn('space-y-2.5', className)}>
      <h3 className='text-[10px] text-gray-700'>Suggested Queries</h3>
      <div className={cn('gap-1', hasLongQueries ? 'flex flex-col' : 'grid grid-cols-1 sm:grid-cols-2')}>
        {queries.map((query) => (
          <Button
            key={query.id}
            variant='outline'
            onClick={() => onSelectQuery(query.text)}
            className='justify-start rounded-xl drop-shadow-lg drop-shadow-black/10 text-left min-h-12 max-h-12 py-3 px-3 border-gray-300 hover:bg-purple-100/50 hover:border-purple-200 hover:text-purple-950 transition-colors h-auto cursor-pointer'
          >
            {query.icon && <span className='mr-2 text-base shrink-0'>{query.icon}</span>}
            <span className='text-xs flex-1 whitespace-normal wrap-break-word leading-none text-gray-900 font-normal'>{query.text}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};
